<template>
  <div class="quadro">

    <div
      v-if="stages.length === 0"
      style="display: flex; justify-content: center; margin-top: 20px;"
    >
      <p style="font-style: italic; color: gray; font-size: 18px; text-align: center;">
        Este funil não possui etapas cadastradas.
      </p>
    </div>

    <draggable
      v-else
      :list="stages"
      v-bind="dragOptions"
      tag="div"
      class="quadro-inner"
      group="stages"
      handle=".stage-handle"
      @change="onStageChanged"
    >
      <transition-group
        class="transition-wrapper"
        type="transition"
        :name="draggingDeals ? null : 'flip-list'"
      >
        <stage-column
          v-for="(stage, stageIndex) in stages"
          :key="stage.id || stageIndex"
          :stage="stage"
          :drag-options="dragOptions"
          @deal-changed="onDealChanged($event.stage, $event.event)"
          @open-deal="$emit('open-deal', $event)"
          @stage-deleted="carregarFunisEtapasOportunidades()"
          @drag-state-change="draggingDeals = $event"
        />
      </transition-group>
    </draggable>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'
import etiquetasApi from '@/app-modulo/comercial/cadastro-proposta/shared/components/cadastro-etiqueta/services/api'
import StageColumn from './StageColumn.vue'

export default {
  name: 'OportunidadesQuadro',
  components: {
    draggable,
    StageColumn,

  },
  props: {
    stages: {
      type: Array,
      default: () => [],
    },
    dragOptions: {
      type: Object,
      required: true,
    },
    funilSelecionado: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['stage-changed', 'deal-change', 'delete-stage', 'open-deal'],
  data() {
    return {
      draggingDeals: false,
    }
  },
  watch: {
    funilSelecionado: {
      immediate: true,
      handler(newVal) {
        this.carregarFunisEtapasOportunidades(newVal)
      },
    },
  },
  methods: {
    toStringTrim(v) {
      if (v === null || v === undefined) return ''
      return String(v).trim()
    },

    normalizarEtiqueta(tag) {
      if (!tag) return null

      let id = null
      if (tag.id !== undefined) id = tag.id
      else if (tag.Id !== undefined) id = tag.Id
      else if (tag.etiquetaId !== undefined) id = tag.etiquetaId
      else if (tag.EtiquetaId !== undefined) id = tag.EtiquetaId

      let descricao = ''
      if (tag.descricao !== undefined) descricao = tag.descricao
      else if (tag.Descricao !== undefined) descricao = tag.Descricao
      else if (tag.nome !== undefined) descricao = tag.nome
      else if (tag.name !== undefined) descricao = tag.name

      descricao = this.toStringTrim(descricao)

      let cor = ''
      if (tag.cor !== undefined) cor = tag.cor
      else if (tag.Cor !== undefined) cor = tag.Cor
      else if (tag.color !== undefined) cor = tag.color

      cor = this.toStringTrim(cor) || '#6c757d'

      let selecionada
      if (tag.selecionada !== undefined) selecionada = tag.selecionada
      else if (tag.Selecionada !== undefined) selecionada = tag.Selecionada

      return {
        id,
        descricao,
        cor,
        selecionada,
      }
    },

    isPropostaAprovada(p) {
      if (!p) return false
      const stNum = Number(p.status)
      if (Number.isFinite(stNum) && (stNum === 3 || stNum === 8)) return true
      if (p.aprovada === true || p.isApproved === true || p.approved === true) return true
      const s = String(p.status || p.situacao || p.state || '').toLowerCase()
      return s.includes('aprovad')
        || s.includes('aceit')
        || s === 'approved'
        || s.includes('ganh')
        || s.includes('conclu')
    },

    escolherPropostaIdParaEtiquetas(propostas) {
      const list = Array.isArray(propostas) ? propostas.filter(p => p && p.id) : []
      if (!list.length) return null

      const aprovadas = list.filter(p => this.isPropostaAprovada(p))
      const baseList = aprovadas.length ? aprovadas : list
      const ids = baseList
        .map(p => Number(p.id))
        .filter(n => Number.isFinite(n))
        .sort((a, b) => b - a)

      return ids[0] || null
    },

    async carregarEtiquetasProposta(propostaId) {
      if (!propostaId) return []
      const res = await etiquetasApi.getEtiquetasProposta(propostaId)
      const arr = Array.isArray(res && res.data ? res.data : null) ? res.data : []
      return arr
        .map(t => this.normalizarEtiqueta(t))
        .filter(t => t && (t.selecionada === undefined || t.selecionada === true))
        .map(t => ({
          id: t.id,
          descricao: t.descricao,
          cor: t.cor,
        }))
    },
    carregarFunisEtapasOportunidades(funilId = null) {
      const funilParaCarregar = funilId || this.funilSelecionado

      if (!funilParaCarregar) {
        return Promise.resolve()
      }

      this.$isLoading(true)
      return api.getPipelineWithStangesAndDeals(funilParaCarregar)
        .then(async response => {
          const funisEtapasOportunidades = response.data
          if (funisEtapasOportunidades && Array.isArray(funisEtapasOportunidades.stages)) {
            this.stages = funisEtapasOportunidades.stages
            this.stages.forEach(stage => {
              if (stage && Array.isArray(stage.deals)) {
                stage.deals.forEach(deal => {
                  this.$set(deal, 'proposalTotal', 0)
                  this.$set(deal, 'proposalCount', 0)
                  this.$set(deal, 'etiquetas', [])
                })
              }
            })
          }

          await this.carregarTotaisPropostas()
        })
        .catch(() => {
          this.$erro(`Erro ao carregar etapas do funil ${funilParaCarregar}, tente novamente mais tarde.`)
        }).finally(() => {
          this.$isLoading(false)
        })
    },
    async onDealChanged(stage, changeEvt) {
      try {
        if (changeEvt && changeEvt.added) {
          const { element, newIndex } = changeEvt.added
          const deal = element
          const targetStageId = stage.id
          this.$isLoading(true)
          await api.updateDeal(deal.id, targetStageId, newIndex + 1)
          this.$sucesso('Oportunidade movida com sucesso.')
        } else if (changeEvt && changeEvt.moved) {
          const { element, newIndex } = changeEvt.moved
          const deal = element
          this.$isLoading(true)
          await api.updateDeal(deal.id, stage.id, newIndex + 1)
          this.$sucesso('Ordem atualizada com sucesso.')
        }
      } catch {
        this.$erro('Erro ao atualizar a oportunidade. Tente novamente.')
        this.carregarFunisEtapasOportunidades()
      } finally {
        this.$isLoading(false)
      }
    },
    carregarTotaisPropostas() {
      const deals = this.listarDealsDoQuadro()
      const ids = Array.from(new Set(deals.map(d => d.id).filter(Boolean)))
      if (!ids.length) return Promise.resolve()

      const maxConcorrencia = 6
      const fila = [...ids]

      const worker = () => {
        const run = () => {
          const id = fila.shift()
          if (!id) return Promise.resolve()
          return this.atualizarTotalPropostasDeal(id).then(run)
        }
        return run()
      }

      return Promise.all(Array.from({ length: Math.min(maxConcorrencia, ids.length) }, worker))
    },
    async atualizarTotalPropostasDeal(dealId) {
      const deal = this.encontrarDealPorId(dealId)
      if (!deal) return

      try {
        const res = await api.getDealProposals(dealId)
        const propostas = (res && res.data) ? res.data : []
        const total = propostas.reduce((acc, p) => {
          const v = Number(p && p.valor !== undefined ? p.valor : 0)
          return acc + (Number.isFinite(v) ? v : 0)
        }, 0)

        this.$set(deal, 'proposalCount', propostas.length)
        this.$set(deal, 'proposalTotal', total)

        const propostaIdParaEtiquetas = this.escolherPropostaIdParaEtiquetas(propostas)
        const etiquetas = await this.carregarEtiquetasProposta(propostaIdParaEtiquetas)
        this.$set(deal, 'etiquetas', etiquetas)
      } catch (e) {
        this.$set(deal, 'proposalCount', 0)
        this.$set(deal, 'proposalTotal', 0)
      }
    },
    encontrarDealPorId(dealId) {
      const idStr = String(dealId)
      const deals = this.listarDealsDoQuadro()
      return deals.find(d => String(d.id) === idStr) || null
    },
    listarDealsDoQuadro() {
      const deals = []
      if (!this.stages || !Array.isArray(this.stages)) return deals

      this.stages.forEach(stage => {
        if (stage && Array.isArray(stage.deals)) {
          stage.deals.forEach(d => {
            if (d && d.id !== null && d.id !== undefined) deals.push(d)
          })
        }
      })
      return deals
    },
    onStageChanged(changeEvt) {
      if (changeEvt && changeEvt.moved) {
        const { element, newIndex } = changeEvt.moved
        const stage = element
        this.$isLoading(true)
        api.updatePipelineStageOrder(stage.id, newIndex + 1)
          .then(() => {
            this.$sucesso('Ordem da etapa atualizada com sucesso.')
            this.carregarFunisEtapasOportunidades()
            this.$emit('stage-changed', stage)
          })
          .catch(() => {
            this.$erro('Erro ao atualizar a ordem da etapa. Tente novamente.')
            this.carregarFunisEtapasOportunidades()
          })
          .finally(() => {
            this.$isLoading(false)
          })
      }
    },
    adicionarNovaEtapa(etapaCriada) {
      if (!etapaCriada || !this.stages) return

      const novaEtapa = {
        ...etapaCriada,
        deals: etapaCriada.deals || [],
      }

      this.stages.push(novaEtapa)
      this.$forceUpdate()
    },
    adicionarNovaOportunidade(oportunidadeCriada) {
      if (!oportunidadeCriada || !this.stages) return

      const { stageId } = oportunidadeCriada
      const stage = this.stages.find(s => s && s.id === stageId)

      if (!stage) return

      const novaOportunidade = {
        id: oportunidadeCriada.id,
        title: oportunidadeCriada.company?.razaoSocial || oportunidadeCriada.person?.nome || 'Não informado',
        personName: oportunidadeCriada.person?.nome || null,
        personId: oportunidadeCriada.personId,
        person: oportunidadeCriada.person || null,
        companyName: oportunidadeCriada.company?.razaoSocial || null,
        companyId: oportunidadeCriada.company?.id || null,
        company: oportunidadeCriada.company || null,
        ownerName: oportunidadeCriada.owner?.nomeCompleto || null,
        ownerId: oportunidadeCriada.ownerId,
        owner: oportunidadeCriada.owner || null,
        stageId: oportunidadeCriada.stageId,
        stage: oportunidadeCriada.stage || null,
        estimatedValue: oportunidadeCriada.estimatedValue,
        expectedCloseDate: oportunidadeCriada.expectedCloseDate,
        actualCloseDate: oportunidadeCriada.actualCloseDate,
        status: oportunidadeCriada.status,
        order: oportunidadeCriada.order,
        proposalCount: 0,
        proposalTotal: 0,
        etiquetas: [],
      }

      if (!stage.deals) {
        this.$set(stage, 'deals', [])
      }

      stage.deals.push(novaOportunidade)
      this.$forceUpdate()
    },
  },
}
</script>
